/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Build_Your_Own_Ai_Afternoon23Inputs */

const en__field_enum_build_your_own_ai_afternoon23 = /** @type {(inputs: _Field_Enum_Build_Your_Own_Ai_Afternoon23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`afternoon only`)
};

const de__field_enum_build_your_own_ai_afternoon23 = /** @type {(inputs: _Field_Enum_Build_Your_Own_Ai_Afternoon23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nur nachmittags`)
};

/**
* | output |
* | --- |
* | "afternoon only" |
*
* @param {_Field_Enum_Build_Your_Own_Ai_Afternoon23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_build_your_own_ai_afternoon23 = /** @type {((inputs?: _Field_Enum_Build_Your_Own_Ai_Afternoon23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Build_Your_Own_Ai_Afternoon23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_build_your_own_ai_afternoon23(inputs)
	return de__field_enum_build_your_own_ai_afternoon23(inputs)
});
export { _field_enum_build_your_own_ai_afternoon23 as "_field_enum_BUILD_YOUR_OWN_AI_AFTERNOON" }